import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Global styles (Tailwind + custom CSS)
import App from "./App"; // Main App component

// Create a root for React to render into (React 18 way)
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the app inside React's StrictMode (helps catch potential issues)
root.render(
  <App />
);
